import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import Navbar from './layout/Navbar';
import Footer from './layout/Footer';
import HorizontalNavbar from './layout/HorizontalNavbar';
import Login from './components/Login';
import OwnerDashboard from './components/OwnerDashboard';
import AgentDashboard from './components/AgentDashboard';
import ChangePassword from './components/ChangePassword';
import AgentForm from './components/AgentForm';
import BulkAgentForm from './components/BulkAgentForm';
import FileDownload from './components/FileDownload';
import GenerateLink from './components/GenerateLink';
import CustomerForm from './components/CustomerForm';
import TermInsuranceForm from './components/TermInsuranceForm';
import ChildEducationForm from './components/ChildEducationForm';
import ChildWeddingForm from './components/ChildWeddingForm';
import HealthInsuranceForm from './components/HealthInsuranceForm';
import FinancialPlanning from './components/FinancialPlanning';
import HomePage from './pages/HomePage';
import ContactUs from './pages/ContactUs';
import Pricing from './pages/Pricing';
import Services from './pages/Services';
import AboutUs from './pages/AboutUs';
import LastLogin from './components/LastLogin';
import useInactivityLogout from './hooks/useInactivityLogout';
import ActivityViewer from './components/ActivityViewer';

import * as api from './services/api'; 

//D:\frontend\financeplanning1\src\services\api.js
// Custom hook to check if the current route is the form route
const useIsFormRoute = () => {
    const location = useLocation();
    return location.pathname.startsWith('/form/');
};

function AppContent() {
    const [userRole, setUserRole] = useState(localStorage.getItem('userRole')); // Initialize from localStorage
    const [userId, setUserId] = useState(localStorage.getItem('userId'));     // Initialize from localStorage
    const [passwordChangeRequired, setPasswordChangeRequired] = useState(localStorage.getItem('passwordChangeRequired') === 'true'); // Initialize from localStorage
    const navigate = useNavigate();
    const isFormRoute = useIsFormRoute();
    const resetInactivityTimer = useInactivityLogout(); // Use the custom hook

     // Pass the reset timer function to the API utility
     useEffect(() => {
        api.setApiResetTimer(resetInactivityTimer);
    }, [resetInactivityTimer]);

    const handleLogout = () => {
        setUserRole(null);
        setUserId(null);
        setPasswordChangeRequired(false);
        localStorage.clear(); // Clear all localStorage items
        navigate('/login'); // Redirect to the login page

    };

   /* const ProtectedRoute = ({ roles, children }) => {
        if (!userRole || !roles.includes(userRole)) { // Check if userRole is null or not in roles
            return <Navigate to="/login" />;
        }
        return children;
    };
    */
    const ProtectedRoute = ({ roles, children }) => {
        const roleInStorage = localStorage.getItem('userRole');
    
        if (!roleInStorage || !roles.includes(roleInStorage)) {
            // Redirect if role not found in localStorage (even if stale state exists)
            return <Navigate to="/login" />;
        }
    
        return children;
    };
    

    //const isFormRoute = useIsFormRoute();

    return (
        <>
            {/* Conditionally render Navbar or HorizontalNavbar */}
            {!isFormRoute && (userRole ? <Navbar userRole={userRole} onLogout={handleLogout} /> : <HorizontalNavbar />)}

            <Routes>
                <Route
                    path="/login"
                    element={
                        <Login
                            setUserRole={setUserRole}
                            setUserId={setUserId}
                            setPasswordChangeRequired={setPasswordChangeRequired}
                        />
                    }
                />

                <Route
                    path="/"
                    element={
                        <div className="main-layout">
                            <div className="main-content">
                                <HomePage />
                            </div>
                        </div>
                    }
                />

                
                <Route
                    path="/contact-us"
                    element={
                        <div className="main-layout">
                            <div className="main-content">
                                <ContactUs />
                            </div>
                        </div>
                    }
                />
                <Route
                    path="/Pricing"
                    element={
                        <div className="main-layout">
                            <div className="main-content">
                                <Pricing />
                            </div>
                        </div>
                    }
                />
                <Route
                    path="/Services"
                    element={
                        <div className="main-layout">
                            <div className="main-content">
                                <Services />
                            </div>
                        </div>
                    }
                />
                <Route
                    path="/AboutUs"
                    element={
                        <div className="main-layout">
                            <div className="main-content">
                                <AboutUs />
                            </div>
                        </div>
                    }
                />
                <Route
                    path="/ownerdashboard"
                    element={
                        <ProtectedRoute roles={['PRIMARY', 'SECONDARY']}>
                            <OwnerDashboard userId={userId} />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/agentdashboard"
                    element={
                        <ProtectedRoute roles={['AGENT']}>
                            <AgentDashboard userId={userId} />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/change-password"
                    element={userRole ? <ChangePassword setPasswordChangeRequired={setPasswordChangeRequired} /> : <Navigate to="/login" />}
                />
                <Route
                    path="/AgentForm"
                    element={
                        <ProtectedRoute roles={['PRIMARY']}>
                            <AgentForm />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/BulkAgentForm"
                    element={
                        <ProtectedRoute roles={['PRIMARY']}>
                            <BulkAgentForm />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/FileDownload"
                    element={
                        <ProtectedRoute roles={['AGENT']}>
                            <FileDownload />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/GenerateLink"
                    element={
                        <ProtectedRoute roles={['AGENT']}>
                            <GenerateLink />
                        </ProtectedRoute>
                    }
                />
                   <Route
                    path="/financial-planning"
                    element={
                        <ProtectedRoute roles={['AGENT']}>
                        <FinancialPlanning />
                        </ProtectedRoute>
                    }
                    />
                    

                <Route
                    path="/last-login"
                    element={
                        <ProtectedRoute roles={['PRIMARY', 'SECONDARY', 'AGENT']}>
                            <LastLogin userId={userId} />
                        </ProtectedRoute>
                    }
                />
                 {/* Add these routes inside your <Routes> component  */}
                   <Route
                    path="/activity/structured"
                    element={
                        <ProtectedRoute roles={['AGENT']}>
                        <ActivityViewer type="structured" />
                        </ProtectedRoute>
                    }
                    />
                    <Route
                    path="/activity/unstructured"
                    element={
                        <ProtectedRoute roles={['AGENT']}>
                        <ActivityViewer type="unstructured" />
                        </ProtectedRoute>
                    }
                    />
                 
                {/* Add CustomerForm Route Here */}
                <Route path="/form/:token" element={<CustomerForm />} />
                <Route path="/form/term-insurance/:token" element={<TermInsuranceForm />} />
                <Route path="/form/child-education/:token" element={<ChildEducationForm />} />
                <Route path="/form/child-wedding/:token" element={<ChildWeddingForm />} />
                <Route path="/form/health-insurance/:token" element={<HealthInsuranceForm/>} />
                


                <Route path="*" element={<Navigate to="/" />} />
            </Routes>

            {/* Conditionally render Footer */}
            {!isFormRoute && <Footer />}
        </>
    );
}

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default App;